/* jshint esversion: 6 */
/* jshint esversion: 8 */
/* jshint ignore:start */
import axios from 'axios';
import { useContext, useEffect } from 'react';
import { MyContext } from '../Context/MyProvider';
import secureLocalStorage from 'react-secure-storage';
const MercadoPago = ({ Amount }) => {

    const { BaseUrl, setPaymentLoading, setPaymentRes } = useContext(MyContext);

    const handlePayment = async () => {
        secureLocalStorage.setItem("Amount", Amount);

        await axios.post(`${BaseUrl}/react_mercadopago/index.php`,
            {
                "amt": Amount
            }
        )
            .then((res) => {
                if (res.data.Result === "true") {
                    window.location.href = res.data.payment_url;
                } else {
                    console.log("react_mercadopago/index.php", res);
                    setPaymentRes("PaymentFaild");
                }
                setPaymentLoading(false);
            });
    };

    useEffect(() => {
        if (!Amount) return;
        handlePayment();
    }, [Amount]);

    return null;
};

export default MercadoPago;
/* jshint ignore:end */